//เพิ่มข่าวสาร หน้า ข่าวสาร
import React, { useRef, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
  ScrollView,
  FlatList,
} from "react-native";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import * as ImagePicker from "expo-image-picker";
import * as ImageManipulator from 'expo-image-manipulator';
import ManageNews from "./manageNews";
import { useRecoilValue } from "recoil";
import { tokenState, univer } from "../reducer";
import { apiservice, BaseUrl } from "../service/api";
import { addImage } from "../utils";
import "react-calendar/dist/Calendar.css";
import Calendar from "react-calendar";
import moment from "moment";
const { width, height } = Dimensions.get("window");

const addNews1 = ({ setpages, state, name }) => {
  const [page, setpage] = useState(0);
  const [value, onChange] = useState(new Date());
  const university = useRecoilValue(univer);
  const token = useRecoilValue(tokenState);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisible1, setModalVisible1] = useState(false);
  const [body, setBody] = useState(state);

  function uploadAdapter(loader) {
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const body = new FormData();
          loader.file.then((file) => {
            console.log(file);
            body.append("image", file);
            // let headers = new Headers();
            // headers.append("Origin", "http://localhost:3000");
            fetch(`${BaseUrl}/image/createck`, {
              method: "post",
              body: body,
              // mode: "no-cors"
            })
              .then((res) => res.json())
              .then((res) => {
                resolve({
                  default: `${BaseUrl}/image/getimage/${res.filename.replace(
                    ".png",
                    ""
                  )}`,
                });
              })
              .catch((err) => {
                reject(err);
              });
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  async function onPress() {
    const res = await apiservice({
      path: "/adv/updateadvuser",
      method: "put",
      body: { ...body, university_id: university.id },
      token: token.accessToken,
    });
    if (res.status == 200) {
      setpages(0);
      setpage(1);
    }
  }

  return (
    <View style={styles.container}>
      {page == 0 && (
        <View
          style={{
            width: width * 0.82,
            height: height * 0.9,
            alignItems: "center",
          }}
        >
          <ScrollView>
            <Text
              style={{
                width: width * 0.591,
                fontSize: 18,
                fontFamily: "Prompt-Regular",
                color: "#202020",
                marginTop: 30,
              }}
            >
              ข่าวสาร
            </Text>

            <View
              style={{
                borderWidth: 0.591,
                borderColor: university.theme.text,
                width: width * 0.591,
                marginVertical: 10,
              }}
            ></View>

            <View style={{ width: width * 0.591, height: height * 0.546 }}>
              <View
                style={{
                  width: 360,
                  borderRadius: 5,
                  marginVertical: 15,
                  overflow: "hidden",
                }}
              >
                <View
                  style={{
                    width: 360,
                    height: 200,
                    overflow: "hidden",
                    borderWidth: 0.5,
                    borderRadius: 5,
                    borderColor: "#00237750",
                  }}
                >
                  <Image
                    style={{ width: 360, height: 200 }}
                    source={{ uri: body.image_url[0] }}
                  />
                </View>
                <Text
                  style={{
                    fontSize: 12,
                    fontFamily: "Prompt-Regular",
                    color: "#ccc",
                  }}
                >
                  ควรอัพโหลดรูปภาพขนาด 16:9
                </Text>
              </View>

              <View
                style={{
                  width: width * 0.235,
                  height: height * 0.037,
                  flexDirection: "row",
                }}
              >
                <Text
                  style={{
                    width: width * 0.8,
                    height: height * 0.037,
                    borderTopLeftRadius: 5,
                    borderBottomLeftRadius: 5,
                    borderWidth: 1,
                    overflow: "hidden",
                    borderColor: "#00237740",
                    paddingLeft: 5,
                    fontFamily: "Prompt-Regular",
                    fontSize: 12,
                  }}
                />
                <TouchableOpacity
                  onPress={async () => {
                    const res = await addImage();

                    if (body.image_url[1]) {
                      setBody((val) => ({
                        ...val,
                        image_url: [res, body.image_url[1]],
                      }));
                    } else {
                      setBody((val) => ({ ...val, image_url: [res] }));
                    }
                  }}
                  style={{
                    width: width * 0.05,
                    height: height * 0.037,
                    backgroundColor: "#002377",
                    borderTopRightRadius: 5,
                    borderBottomRightRadius: 5,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: "Prompt-Regular",
                      color: "#FFF",
                      margin: "auto",
                    }}
                  >
                    อัพโหลดรูป
                  </Text>
                </TouchableOpacity>
              </View>

              {/* <View style={{width:width*0.591,height:height*0.037,flexDirection:"row",justifyContent:"space-between",marginVertical:15}}>

                <View style={styles.Boxarea}> 
                    <Text style={styles.Text18}>ชื่อโฆษณา</Text> 
                    <TextInput style={styles.TextInput}/>
                </View>
                <View style={styles.Boxarea}>
                    <Text style={styles.Text18}>Link</Text> 
                    <TextInput style={styles.TextInput}/>
                </View>

                </View> */}
              <View
                style={{
                  width: width * 0.53,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={styles.Boxarea}>
                  <Text style={styles.Text18}>วิดีโอ URL</Text>
                  <TextInput
                    value={body.image_url[1]}
                    onChangeText={(text) => {
                      setBody((val) => ({
                        ...val,
                        image_url: [val.image_url[0], text],
                      }));
                    }}
                    style={styles.TextInput}
                  />
                </View>
                <View style={styles.Boxarea}></View>
              </View>
              <View
                style={{
                  width: width * 0.53,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={styles.Boxarea}>
                  <Text style={styles.Text18}>ชื่อหัวข้อ</Text>
                  <TextInput
                    value={body.title}
                    onChangeText={(text) => {
                      setBody((val) => ({ ...val, title: text }));
                    }}
                    style={styles.TextInput}
                  />
                </View>
                <View style={styles.Boxarea}>
                  <Text style={styles.Text18}>ผู้เขียน</Text>
                  <TextInput
                    value={body.post_by}
                    onChangeText={(text) => {
                      setBody((val) => ({ ...val, post_by: text }));
                    }}
                    style={styles.TextInput}
                  />
                </View>
              </View>

              <View
                style={{
                  width: width * 0.53,
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <View style={styles.Boxarea}>
                  <Text style={styles.Text18}>วันที่</Text>

                  <TouchableOpacity
                    onPress={() => {
                      setModalVisible1(false);

                      setModalVisible((val) => !val);
                    }}
                  >
                    <Text style={styles.TextInput}>
                      {moment(body.startdate)
                        .add(543, "years")
                        .format("DD/MM/YYYY")}
                    </Text>
                  </TouchableOpacity>
                </View>
                <View onPress={() => { }} style={styles.Boxarea}>
                  <Text style={styles.Text18}>ถึง</Text>
                  <TouchableOpacity
                    onPress={() => {
                      setModalVisible(false);

                      setModalVisible1((val) => !val);
                    }}
                  >
                    <Text style={styles.TextInput}>
                      {moment(body.date).add(543, "years").format("DD/MM/YYYY")}
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>

              <View style={{ flexDirection: "row", marginLeft: width * 0.05 }}>
                <View style={[styles.Boxarea, { height: null }]}>
                  {modalVisible == true && (
                    <Calendar
                      onChange={(value) => {
                        setModalVisible(false);
                        setBody((val) => ({ ...val, startdate: value }));
                      }}
                      value={value}
                    />
                  )}
                </View>
                <View
                  style={[
                    styles.Boxarea,
                    { height: null, marginLeft: width * 0.05 },
                  ]}
                >
                  {modalVisible1 == true && (
                    <Calendar
                      onChange={(value) => {
                        setModalVisible1(false);

                        setBody((val) => ({ ...val, date: value }));
                      }}
                      value={value}
                    />
                  )}
                </View>
              </View>
              <View
                style={{
                  width: width * 0.43,
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginVertical: 15,
                }}
              >
                <Text style={[styles.Text18, { alignSelf: "center" }]}>
                  รายละเอียด
                </Text>

                <CKEditor
                  config={{
                    extraPlugins: [uploadPlugin],
                  }}
                  editor={ClassicEditor}
                  data={body.description}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    // console.log("Editor is ready to use!", editor);
                  }}
                  onChange={async (event, editor) => {
                    const data = await editor.getData();
                    setBody((val) => ({
                      ...val,
                      description: data,
                    }));
                  }}
                  onBlur={(event, editor) => {
                    // console.log("Blur.", editor);
                  }}
                  onFocus={(event, editor) => {
                    // console.log("Focus.", editor);
                  }}
                />
              </View>

              <View
                style={{
                  width: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <TouchableOpacity
                  onPress={async () => {
                    // const res = await addImage();

                    // setBody((val) => ({
                    //   ...val,
                    //   img_description: val.img_description.concat({
                    //     res,
                    //   }),
                    // }));
                    let result = await ImagePicker.launchImageLibraryAsync({
                      mediaTypes: ImagePicker.MediaTypeOptions.Images,
                      base64: true,
                    });

                    const manipulated = await ImageManipulator.manipulateAsync(
                      result.uri,
                      [{ resize: { width: 800 } }], // ปรับตามที่ต้องการ เช่น width = 800px
                      { compress: 0.8, format: ImageManipulator.SaveFormat.PNG, base64: true }
                    );

                    const response = await apiservice({
                      path: "/image/create",
                      method: "post",
                      body: {
                        name: new Date().getTime() + ".jpg",
                        base64: manipulated.base64,
                      },
                    });

                    console.log("img", response.data);
                    setBody((val) => ({
                      ...val,
                      img_description: val.img_description.concat({
                        res:
                          BaseUrl +
                          "/image/getimage/" +
                          response.data.imageRefId
                            .replace(".png", "")
                            .replace(".jpg", "")
                            .replace(".jpeg", ""),
                        width: result.width,
                        height: result.height,
                      }),
                    }));
                  }}
                  style={{
                    width: width * 0.06,
                    height: height * 0.037,
                    backgroundColor: "#002377",
                    borderRadius: 5,
                  }}
                >
                  <Text
                    style={{
                      fontSize: 16,
                      fontFamily: "Prompt-Regular",
                      color: "#FFF",
                      margin: "auto",
                    }}
                  >
                    อัพโหลดรูป
                  </Text>
                </TouchableOpacity>

                <FlatList
                  data={body.img_description}
                  horizontal
                  renderItem={({ item, index }) => {
                    console.log("F", item);
                    return (
                      <>
                        <View
                          style={{
                            borderWidth: 5,
                            borderRadius: 10,
                            borderColor: "#fff",
                            height: 80,
                          }}
                        >
                          <Image
                            style={{ width: 100, height: 100 }}
                            source={{ uri: item.res }}
                          />
                        </View>
                        <TouchableOpacity
                          onPress={() => {
                            setBody((val) => ({
                              ...val,
                              img_description: val.img_description.filter(
                                (i, e) => {
                                  return i != item;
                                }
                              ),
                            }));
                          }}
                          style={{ marginLeft: -24 }}
                        >
                          <AntDesign name="close" size={24} color="#000" />
                        </TouchableOpacity>
                      </>
                    );
                  }}
                />
              </View>
              <View style={styles.Boxareabutton}>
                <TouchableOpacity
                  onPress={onPress}
                  style={{
                    width: 100,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#69D443",
                    marginRight: 20,
                  }}
                >
                  <Text style={styles.TextButton}>ยืนยัน</Text>
                </TouchableOpacity>

                <TouchableOpacity
                  onPress={() => setpages(0)}
                  style={{
                    width: 100,
                    height: 40,
                    borderRadius: 5,
                    backgroundColor: "#D44343",
                  }}
                >
                  <Text style={styles.TextButton}>ยกเลิก</Text>
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        </View>
      )}
      {page == 1 && <ManageNews />}
    </View>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#ffff",
  },
  Boxarea: {
    width: width * 0.25,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginVertical: 15,
  },
  Boxareabutton: {
    width: width * 0.297,
    height: height * 0.037,
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 70,
  },
  Text18: { fontSize: 16, fontFamily: "Prompt-Regular" },
  TextInput: {
    width: width * 0.182,
    height: height * 0.037,
    borderWidth: 0.5,
    borderColor: "#00237740",
    borderRadius: 5,
    paddingLeft: 10,
    fontSize: 16,
    fontFamily: "Prompt-Regular",
  },
  TextButton: {
    fontSize: 16,
    color: "#ffff",
    margin: "auto",
    fontFamily: "Prompt-Regular",
  },
});

export default addNews1;
